import axios from "../../config/interceptor";
import { PER_PAGE_SIZE } from "../../utils/constants";

// Get pharmacy list with pagination and filters
export const getPharmacyList = async ({
  page = 0,
  size = PER_PAGE_SIZE,
  businessId,
}) => {
  try {
    let link = `/lambda/v1/pharmacy/${businessId}?`;
    link = link.concat("page=" + page);
    link = link.concat("&size=" + size);

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};

// Get pharmacy detail by ID
export const getPharmacyDetail = async (id) => {
  try {
    const response = await axios.get(`/lambda/v1/pharmacy/detail/${id}`);

    return response;
  } catch (error) {
    return error;
  }
};

// Update pharmacy status (e.g., from WAITING_MEDICINE to MEDICINE_READY)
export const updatePharmacyStatus = async (data) => {
  try {
    const response = await axios.put(
      `/lambda/v1/pharmacy/${data.pharmacyId}/status`,
      {
        status: data.status,
        notes: data.notes,
        businessId: data.businessId,
      }
    );

    return response;
  } catch (error) {
    return error;
  }
};

export const getCountPharmacy = async ({ businessId }) => {
  try {
    let link = `/lambda/v1/pharmacy/${businessId}/count`;

    const response = await axios.get(link);

    return response;
  } catch (error) {
    return error;
  }
};
